import { useState } from 'react';
import { MeasurementGraphSettings } from './measurementGraphSettings.ts';


const defaultSettings: MeasurementGraphSettings = {
    lineVisibilities: { nominal: true, tolerance: true, mean: true, }
};


export function useSettings() {
    const [settings, setSettings] = useState<MeasurementGraphSettings>(loadOptions());


    function loadOptions(): MeasurementGraphSettings {
        const options = localStorage.getItem('measurementGraphSettings');
        return options ? JSON.parse(options) : defaultSettings;
    }

    function handleSettingsChange(newSettings: MeasurementGraphSettings) {
        setSettings(newSettings);
        localStorage.setItem('measurementGraphSettings', JSON.stringify(newSettings));
    }

    return {
        settings,
        setSettings: handleSettingsChange
    }
}
